(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
/**
 * AnnouncementCountdown — bar ticker Web Component.
 * Reads data-end (ISO datetime string, interpreted as PT) and counts down.
 * Auto-hides the entire announcement section when the deadline passes.
 */
class AnnouncementCountdown extends HTMLElement {
  #interval = null;
  #endMs = 0;

  connectedCallback() {
    const rawEnd = this.dataset.end;
    if (!rawEnd) return;

    // Parse the datetime string as Pacific Time.
    // The Shopify date_time picker gives "YYYY-MM-DDTHH:MM" (no timezone).
    // We append the PT offset so the browser treats it correctly.
    this.#endMs = this.#parsePacificTime(rawEnd);
    if (!this.#endMs) return;

    this.#tick();
    this.#interval = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#interval);
  }

  /**
   * Parse a "YYYY-MM-DDTHH:MM" string as America/Los_Angeles.
   * Uses Intl to work out whether PT is currently PST (-08:00) or PDT (-07:00).
   * @param {string} raw
   * @returns {number} milliseconds since epoch
   */
  #parsePacificTime(raw) {
    try {
      // Append a UTC offset that matches the current PT offset.
      const offset = this.#getPacificOffset(raw);
      return new Date(`${raw}:00${offset}`).getTime();
    } catch {
      return 0;
    }
  }

  /**
   * Determine the UTC offset for America/Los_Angeles at a given naive datetime string.
   * @param {string} naiveDatetime "YYYY-MM-DDTHH:MM"
   * @returns {string} e.g. "-08:00" or "-07:00"
   */
  #getPacificOffset(naiveDatetime) {
    // Probe using UTC midnight to avoid chicken-and-egg, then refine.
    const probe = new Date(`${naiveDatetime}:00Z`);
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'shortOffset'
    });
    const parts = formatter.formatToParts(probe);
    const tz = parts.find(p => p.type === 'timeZoneName')?.value ?? 'GMT-8';
    // tz is like "GMT-7" or "GMT-8"
    const match = tz.match(/GMT([+-]\d+)/);
    if (!match) return '-08:00';
    const hrs = parseInt(match[1], 10);
    const pad = String(Math.abs(hrs)).padStart(2, '0');
    return `${hrs < 0 ? '-' : '+'}${pad}:00`;
  }

  #tick() {
    const now = Date.now();
    const remaining = this.#endMs - now;

    if (remaining <= 0) {
      this.#expire();
      return;
    }

    const { days, hours, minutes, seconds } = this.#breakdown(remaining);

    // Render as "01d : 09h : 10m : 16s" in the single ticker span
    const ticker = this.querySelector('[data-countdown-ticker]');
    if (ticker) {
      const d = String(days).padStart(2, '0');
      const h = String(hours).padStart(2, '0');
      const m = String(minutes).padStart(2, '0');
      const s = String(seconds).padStart(2, '0');
      ticker.textContent = `${d}d : ${h}h : ${m}m : ${s}s`;
    }

    // Also sync any matching panel countdown (same section)
    this.#syncPanel({ days, hours, minutes, seconds });
  }

  #syncPanel({ days, hours, minutes, seconds }) {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;
    const section = document.getElementById(`announcement-${sectionId}`);
    if (!section) return;

    // Sync panel countdown digits
    const panel = section.querySelector('[data-countdown-panel]');
    if (panel) {
      const set = (attr, val) => {
        const el = panel.querySelector(`[${attr}]`);
        if (el) el.textContent = val;
      };
      set('data-panel-countdown-days', String(days).padStart(2, '0'));
      set('data-panel-countdown-hours', String(hours).padStart(2, '0'));
      set('data-panel-countdown-minutes', String(minutes).padStart(2, '0'));
      set('data-panel-countdown-seconds', String(seconds).padStart(2, '0'));
    }

  }

  #breakdown(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
  }

  #expire() {
    clearInterval(this.#interval);
    // Hide the entire announcement section gracefully
    const sectionId = this.dataset.sectionId;
    if (sectionId) {
      const section = document.getElementById(`announcement-${sectionId}`);
      if (section) {
        section.style.transition = 'opacity 0.4s ease, max-height 0.4s ease';
        section.style.overflow = 'hidden';
        section.style.opacity = '0';
        section.style.maxHeight = '0';
        setTimeout(() => section.remove(), 500);
      }
    }
  }
}

customElements.define('announcement-countdown', AnnouncementCountdown);

/**
 * Panel countdown — handles the expanded drawer's countdown panels.
 * Standalone panels (not inside the bar Web Component) fall back to this.
 */
(function initPanelCountdowns() {
  function getPacificOffset(naiveDatetime) {
    const probe = new Date(`${naiveDatetime}:00Z`);
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'shortOffset'
    });
    const parts = formatter.formatToParts(probe);
    const tz = parts.find(p => p.type === 'timeZoneName')?.value ?? 'GMT-8';
    const match = tz.match(/GMT([+-]\d+)/);
    if (!match) return '-08:00';
    const hrs = parseInt(match[1], 10);
    const pad = String(Math.abs(hrs)).padStart(2, '0');
    return `${hrs < 0 ? '-' : '+'}${pad}:00`;
  }

  function parsePT(raw) {
    try {
      return new Date(`${raw}:00${getPacificOffset(raw)}`).getTime();
    } catch {
      return 0;
    }
  }

  function breakdown(ms) {
    const total = Math.floor(ms / 1000);
    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60
    };
  }

  // Panels that aren't already driven by the bar Web Component
  const panels = document.querySelectorAll('[data-countdown-panel]');
  for (const panel of panels) {
    const raw = panel.dataset.end;
    if (!raw) continue;
    const endMs = parsePT(raw);
    if (!endMs) continue;

    // Skip if already synced by the bar component
    const barComponent = panel.closest('section')?.querySelector('announcement-countdown');
    if (barComponent) continue;

    const tick = () => {
      const remaining = endMs - Date.now();
      if (remaining <= 0) {
        panel.style.display = 'none';
        clearInterval(id);
        return;
      }
      const { days, hours, minutes, seconds } = breakdown(remaining);
      const set = (attr, val) => {
        const el = panel.querySelector(`[${attr}]`);
        if (el) el.textContent = String(val).padStart(2, '0');
      };
      set('data-panel-countdown-days', days);
      set('data-panel-countdown-hours', hours);
      set('data-panel-countdown-minutes', minutes);
      set('data-panel-countdown-seconds', seconds);
    };

    tick();
    const id = setInterval(tick, 1000);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
